/**
 * Grade label canonicalization for materials catalog + proposal pricing.
 * Pure helpers (no Firebase) so casing drift like #2/BTR vs #2/Btr collapses.
 */

/**
 * Canonical grade label for storage/UI.
 * Collapses casing drift like "#2/Btr" → "#2/BTR"; keeps word grades title-cased.
 */
export function canonicalizeGrade(raw?: string | null): string {
  const s = (raw || '').trim();
  if (!s) return '';
  if (/[#/]/.test(s) || /^(fas|ss|fohc)$/i.test(s)) {
    return s.toUpperCase();
  }
  if (/^(select|standard|construction|utility)$/i.test(s)) {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  return s;
}

/** Case-insensitive grade equality (#2/BTR === #2/Btr). */
export function gradesEquivalent(a?: string | null, b?: string | null): boolean {
  return (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();
}

/** Unique grades by case-insensitive key, preferring canonicalizeGrade. */
export function uniqueCanonicalGrades(grades: string[]): string[] {
  const best = new Map<string, string>();
  for (let i = 0; i < grades.length; i++) {
    const trimmed = (grades[i] || '').trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    const canon = canonicalizeGrade(trimmed);
    const prev = best.get(key);
    if (!prev || prev !== canon) best.set(key, canon);
  }
  return Array.from(best.values()).sort((a, b) => a.localeCompare(b));
}
